import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card'

import GroupsList from './GroupsList'
import AddButton from './AddButton'
import Section from './SectionMessage'

import { notificationsGroups } from 'selectors/notifications'

import commentActions from 'actions/commentActions'
import dataActions from 'actions/dataActions'
import Wizard from './wizardComment'

let select = (state, props) => ({
	mode: state.commentBuffer.mode
  , accordion: state.accordion
  , notificationsGroups: notificationsGroups(state, props)
})

export class Comments extends Component {
	handleChange = (event, index, value1) => this.setState({value1});
	render(){
		let { props } = this
		let commentQuery = props.commentQuery || (window.location.search.indexOf("comments") == -1? false : true)

		return(
			<Section
				id="comments"
				title={<span style={{fontWeight: "bold", fontSize: "16px"}}>MESSAGES</span>}
				badge={props.notificationsGroups && props.notificationsGroups.counter || 0}
				rightButton={<AddButton commentWizard={true} />}
				style={{padding:"0px", height: "76px"}}
			>
				{props.accordion == "commentWizard" && <Wizard propertyID={props.objectID} path={props.path}/>}
				<GroupsList mode={props.mode} objectID={this.props.objectID} path={props.path}/>
			</Section>
		)
	}
}

export default connect(select, R.mergeAll([dataActions, commentActions]))(Comments)



// WEBPACK FOOTER //
// ./src/components/Communication/index.js